import { useState, useEffect } from 'react';
import { getLoginState } from 'model/user';
import repo from 'service/repository';
import mqtt from 'service/mqtt';
import { INIT_APP_DONE, UPDATE_BOOTSTRAPS } from 'use-app';
import { PATH } from 'config';
import { connectMQTT } from 'helpers/connect-mqtt';

const useInit = () => {
  const [isPending, setIsPending] = useState(true);

  useEffect(() => {
    setIsPending(false);

    return () => mqtt.disconnect();
  }, []);

  return {
    isPending,
  };
};

const loginAsUser = (success, failure) => {
  return Promise.all([
    repo.fetchUserInfo(),
    repo.fetchLicensePlates(),
    repo.fetchBootstraps(),
    repo.fetchParkingRecord(),
    repo.fetchOrders(1, 100, ['refueling']),
    repo.fetchOrders(1, 100, ['parking']),
    repo.agreeTermsOfTaipeiParkinglotService(),
  ])
    .then(data => {
      const payload = {
        me: data[0],
        licensePlates: data[1],
        bootstraps: data[2],
        parkingRecord: data[3],
        orders: {
          refueling: data[4].data,
          parking: data[5].data,
        },
      };

      success(payload);
    })
    .catch(e => {
      failure(e);
    });
};

const useSplash = async ({ state, dispatch, history, location }, callback) => {
  const waitForSplashAnimationComplete = fn => {
    return new Promise(resolve => {
      resolve(callback());
    }).then(() => {
      setTimeout(() => fn(), 2200);
    });
  };

  const initAppWithoutPayload = () => dispatch({ type: INIT_APP_DONE });

  await repo.fetchBootstraps().then(payload => {
    dispatch({
      type: UPDATE_BOOTSTRAPS,
      payload,
    });
  });

  // 因應發 edm 做的調整
  if (location.pathname === PATH.MAPS || location.pathname === PATH.SERVICE_INSTRUCTION) {
    return waitForSplashAnimationComplete(initAppWithoutPayload);
  }

  switch (getLoginState()) {
    case 'user':
      const success = payload => {
        waitForSplashAnimationComplete(() => {
          dispatch({
            type: INIT_APP_DONE,
            payload: payload,
          });
          connectMQTT({ state, dispatch });

          if (location.pathname === '/' || location.pathname === '/index.html') {
            history.replace(PATH.MAIN);
          } else {
            history.replace(`${location.pathname}${location.search}${location.hash}`);
          }
        });
      };

      const failure = () => {
        waitForSplashAnimationComplete(() => {
          initAppWithoutPayload();
          history.replace(PATH.USER_WELCOME);
        });
      };

      loginAsUser(success, failure);

      break;
    case 'skip':
      waitForSplashAnimationComplete(() => {
        initAppWithoutPayload();
        history.replace(PATH.MAIN);
      });
      break;
    default:
      waitForSplashAnimationComplete(() => {
        initAppWithoutPayload();
        if (location.pathname !== PATH.USER_LOGIN) {
          history.replace(PATH.USER_WELCOME);
        }
      });
      break;
  }
};

const methods = {
  useInit,
  useSplash,
  loginAsUser,
};

export default methods;
